module.exports = __webpack_public_path__ + "img/non_inventory.9f04bee4.png";